// Here we chose to use the native `structuredClone` function,
// but if we spot any compatibility issue, we can fallback to:
// Node ESM requires explicit file extension; lodash package doesn't provide exports map
// export { default as cloneDeep } from 'lodash/cloneDeep.js'

const cloneDeep = structuredClone

export { cloneDeep }
